import React, { useState } from 'react';
import { Button } from '../core/button';
import { ArchiveModal } from './ArchiveModal';
import styles from './archive.module.scss';
import FontAwesomeIcon from '../core/fa_icon';

/**
 * Button which opens an archive modal.
 */
export const ArchiveReferrer: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={styles.referrerContainer}>
        <Button
          className={styles.referrer}
          onClick={() => setOpen(open => !open)}
          title="Öppna eller stäng arkiv">
          <FontAwesomeIcon name="archive" />
        </Button>
      </div>

      <ArchiveModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}